import { useState } from "react";
import { FiImage, FiTrash2, FiUpload } from "react-icons/fi";
import { Container } from "./style";
import emptyImg from "../../../assets/img/empty-img.svg"
import { URL_PUBLIC } from "../../../services/api";

type Props = {
    label: string,
    logoUrl?: string,
    changeLogoFile?: (value: any) => void
}

export const UploadImg = ({ label, changeLogoFile, logoUrl }: Props): JSX.Element => {
    const [picture, setPicture] = useState<string | undefined>(undefined);
    const [imgData, setImgData] = useState<any>(undefined);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.files?.[0];

        if (!selected) {
            setPicture(undefined);
            setImgData(undefined);
            changeLogoFile?.(undefined);
            return;
        }

        setPicture(selected.name);

        const reader = new FileReader();
        reader.onload = () => {
            setImgData(reader.result);
            changeLogoFile?.(reader.result);
        };
        reader.readAsDataURL(selected);
    };

    const deletePicture = (): void => {
        setPicture(undefined)
        setImgData(undefined)
        changeLogoFile?.(undefined);

        const input = document.getElementById('logoImgFile') as HTMLInputElement | null;
        if (input) input.value = '';
    }

    const previewSrc = imgData
        || (logoUrl
            ? (logoUrl.startsWith('data:') || logoUrl.startsWith('http') ? logoUrl : `${URL_PUBLIC}${logoUrl}`)
            : emptyImg)

    return (
        <Container>
            <div>{label}</div>

            <div className="previewProfilePic">
                {(logoUrl || imgData) && (
                    <button type="button" className="trash" onClick={deletePicture} aria-label="Remover imagem">
                        <FiTrash2 size={16} />
                    </button>
                )}
                {previewSrc === emptyImg ? (
                    <div className="image-placeholder">
                        <FiImage size={36} />
                    </div>
                ) : (
                    <img className="playerProfilePic_home_tile" src={previewSrc} alt="preview" />
                )}
                <div className="text">{picture}</div>
            </div>

            <div className="register_profile_image">
                <label htmlFor="logoImgFile" className="btn radius-100">
                    <FiUpload className="download-icon" size={16} color="#FFFFFF" />
                    <span>Adicionar</span>
                </label>
                <input id="logoImgFile" type="file" style={{ visibility: "hidden" }} accept="image/png, image/jpeg" onChange={handleChange} />
            </div>
        </Container>
    )
}
